__turbopack_context__.v({
  "body": "dialog-module__gZg_3q__body",
  "close": "dialog-module__gZg_3q__close",
  "content": "dialog-module__gZg_3q__content",
  "contentShow": "dialog-module__gZg_3q__contentShow",
  "description": "dialog-module__gZg_3q__description",
  "footer": "dialog-module__gZg_3q__footer",
  "header": "dialog-module__gZg_3q__header",
  "overlay": "dialog-module__gZg_3q__overlay",
  "overlayShow": "dialog-module__gZg_3q__overlayShow",
  "sheetShow": "dialog-module__gZg_3q__sheetShow",
  "title": "dialog-module__gZg_3q__title",
});
